<script setup lang="ts">
import type { CSSProperties } from 'vue'

const props = defineProps<{
  err: string | None | string[]
}>()

const elem = useTemplateRef('elem')
const data = shallowReactive({
  style: { width: '0px' } as CSSProperties,
  msg: '',
})

function timerStart() {
  const timer = useTimeout()
  let index = 0

  return {
    start(): typeof timer {
      const cur = index + 1
      index = cur
      const on = () => cur === index

      return {
        active: () => timer.active() && on(),
        clear: () => {
          timer.clear()
          index += 1
        },
        set: (a, b) => on() && timer.set(() => on() && a(), b),
      }
    },
  }
}

const timerWithStart = timerStart()

watch(
  () => props.err,
  (err) => {
    const msg = helpers.joinStringCb(', ', helpers.arrify(err), (i) => i) || ''
    data.msg = msg
    const timer = timerWithStart.start()
    timer.set(() => {
      const w = myElem(elem.value, 'scrollWidth')
      data.style = { width: !msg.length ? '0px' : !w ? 'auto' : w + 'px' }
    }, 10)
  }
)
</script>

<template>
  <span :style="data.style" :class="$style.err">
    <span ref="elem" class="_pr08 _pb02 _pl02">{{ data.msg }}</span>
    <span :class="$style.bubble">
      <span :class="$style.blink">!</span>
    </span>
  </span>
</template>

<style module>
.err {
  composes: global(_relative);
  composes: global(_flexline);

  composes: global(_gap06);
  composes: global(_fs08);
  composes: global(_ls-xs);
  composes: global(_fw-l);
  composes: global(_h14);
  composes: global(_hidden);
  composes: global(_noselect);

  composes: global(_ws_nowrap);
  composes: global(_red);

  z-index: 0;

  align-items: center;

  word-break: keep-all;
  font-style: italic;
  transition: width 300ms var(--tran2);
  will-change: width;
}

.bubble {
  composes: global(_row);
  composes: global(_absolute);
  composes: global(_h100p);
  composes: global(_end);

  bottom: 1px;
  left: 2px;
  border: 0 solid currentColor;
  border-width: 0 0px 1px 0;
  background: transparent;
  transform: skewX(-14deg);
  right: 0;
}

.blink {
  composes: global(_fw-xxl);
  composes: global(_fs09);
  composes: global(_pr02);

  font-style: initial;
  animation: blink 2s cubic-bezier(0, 1, 0, 1) 1s infinite;
}

@keyframes blink {
  0%,
  to {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
</style>
